import { AxiosError } from "axios";
import { isBaseError, toBaseError } from "../../utils/base_error";
import { axiosInstance } from "../../utils/axios_instance";
import { handleAxiosResponse } from "../../utils/axios_response";
import { ICommonsService } from "./commons_service";
import { GetCargosDropDownResponse } from "../daos/read/get_cargos_dropdown";
import { GetFuncionariosDropDownRequest, GetFuncionariosDropDownResponse } from "../daos/read/get_funcionarios_dropdown";
import { GetPageSizeRequest, GetPageSizeResponse } from "../daos/read/get_page_size";
import { GetAllLogAlteracaoRequest, GetAllLogAlteracaoResponse } from "../daos/read/get_all_log_alteracao";
import { GetAllLogAlteracaoByParentRequest, GetAllLogAlteracaoByParentResponse } from "../daos/read/get_all_log_alteracao_by_parent";
import { GetFuncionariosByIdCentroCustoDropDownRequest, GetFuncionariosByIdCentroCustoDropDownResponse } from "../daos/read/get_funcionarios_by_id_centro_custo_dropdown";
import { GetUsuarioDropDownResponse, UsuarioDropDownDao } from "../daos/read/get_usuario_drop_down";
import { CreateGedDocumentoRequest, CreateGedDocumentoResponse } from "../daos/create/create_ged_documento";
import { UpdateGedDocumentoRequest, UpdateGedDocumentoResponse } from "../daos/update/update_ged_documento";
import { DeleteGedDocumentoRequest, DeleteGedDocumentoResponse } from "../daos/delete/delete_ged_documento";
import { GetAllGedDocumentoRequest, GetAllGedDocumentoResponse } from "../daos/read/get_all_ged_documento";
import { CopyGedDocumentoRequest, CopyGedDocumentoResponse } from "../daos/create/copy_ged_documento";
import { GetClienteDropDownDao, GetClienteDropDownListRequest, GetClienteDropDownListResponse } from "../daos/read/get_cliente_dropdown";
import { GetOrdemCompraDropDownRequest, GetOrdemCompraDropDownResponse } from "../daos/read/get_ordem_compra_dropdown";
import { GetSubcontaDropDownResponse, SubContaDropDownDao } from "../daos/read/get_subconta_dropdown";
import { BancoDropDownDao, GetBancoDropDownResponse } from "../daos/read/get_banco_dropdown";
import { GetFornecedorDropDownRequest, GetFornecedorDropDownResponse } from "../daos/read/get_fornecedor_drop_down";
import { CreateClienteSimplificadoRequest, CreateClienteSimplificadoResponse } from "../daos/create/create_cliente_simplificado";
import { CreateSubcontaSimplificadoRequest, CreateSubcontaSimplificadoResponse } from "../daos/create/create_subconta_simplificado";
import { GetUnidadeDropDownRequest, GetUnidadeDropDownResponse } from "../daos/read/get_unidade_dropdown";
import { GetDropDownResponse } from "../daos/read/get_dropdown";
import { GetAllAuditorAuditoresRequest } from "../../../features/auditoria/data/daos/read/get_all_auditor_auditores";
import { GetFuncionarioByIdUsuarioRequest, GetFuncionarioByIdUsuarioResponse } from "../daos/read/get_funcionario_by_id_usuario";
import { GetNomeAuditorDropDownResponse } from "../daos/read/get_nome_auditor_drop_down";
import { GetDataAuditoriaDropDownRequest, GetDataAuditoriaDropDownResponse } from "../daos/read/get_data_auditoria_drop_down";
import { GetDataCronogramaSGQDropDownRequest, GetDataCronogramaSGQDropDownResponse } from "../daos/read/get_data_CronogramaSGQ_drop_down";
import { GetFuncionariosTercDropDownRequest, GetFuncionariosTercDropDownResponse } from "../daos/read/get_funcionarios_terc_drop_down";
import { GetDataProvisaoRecursoDropDownRequest, GetDataProvisaoRecursoDropDownResponse } from "../daos/read/get_data_provisao_recurso_drop_down";
import { GetIndicadoresDropDownResponse, IndicadoresDropDownDao } from "../daos/read/get_Indicadores_dropdown";
import { CentroCustoDropDownDao, GetCentroCustoDropDownRequest, GetCentroCustoDropDownResponse } from "../daos/read/get_centro_custo_dropdown";
import { EquipamentosDropDownDao, GetEquipamentosDropDownResponse } from "../daos/read/get_equipamentos_dropdown";
import { GetContratoDropDownDao, GetContratoDropDownResponse } from "../daos/read/get_contrato_drop_down";
import { GetProdutosServicosDropDownRequest, GetProdutosServicosDropDownResponse } from "../daos/read/get_produtos_servicos_drop_down";
import { GetRequisicaoCompraDropDownRequest, GetRequisicaoCompraDropDownResponse } from "../daos/read/get_requisicao_compra_drop_down";
import { GetAtributosCompraRequest, GetAtributosCompraResponse } from "../daos/read/get_atributos_compra";
import { GetColetaPrecoDropDownRequest, GetColetaPrecoDropDownResponse } from "../daos/read/get_coleta_preco_drop_down";
import { GetGrupoAcessoDropDownResponse } from "../daos/read/get_grupo_acesso_drop_down";
import { GEDTornarObsoletosRequest, GEDTornarObsoletosResponse } from "../daos/update/ged_tornar_obsoletos";
import { GetGedArquivoDataRequest } from "../daos/read/get_ged_arquivo_data";
import { GetGedArquivoPdfDataRequest } from "../daos/read/get_ged_arquivo_pdf_data";
import { GetContratoFinanceiroRequest, GetContratoFinanceiroResponse } from "../daos/read/get_contratos_financeiro_dropdown";
import { GetClienteCentroCustoDropDownRequest, GetClienteCentroCustoDropDownResponse } from "../daos/read/get_cliente_centro_custo_dropdown";
import { GetProjetosDropDownRequest, GetProjetosDropDownResponse } from "../daos/read/get_projetos_drop_down";
import { GetPrincipalDocRequest, GetPrincipalDocResponse } from "../daos/read/get_principal_doc";
import { RequestObjectToFormData } from "../../utils/form_data_utils";
import { SaveUsuarioTableSchemeRequest, SaveUsuarioTableSchemeResponse } from "../daos/update/save_usuario_table_scheme";
import { GetDropDownProdutoServicoResponse } from "../daos/read/get_dropdown_produto_servico";
import { GetFornecedorDadosByCnpjRequest, GetFornecedorDadosByCnpjResponse } from "../daos/read/get_fornecedor_dados_by_cnpj";
import { GetJobStatusRequest, GetJobStatusResponse } from "../daos/read/get_job_status";

/**
 * CommonsService
 */


export class CommonsService implements ICommonsService {

  async getJobStatus(request: GetJobStatusRequest): Promise<GetJobStatusResponse> {
    try {
      const result = await axiosInstance({}).get(`/jobs/${encodeURIComponent(request.operacaoId)}`);
      return handleAxiosResponse<GetJobStatusResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }


  async getCentroCustoDropDown(request: GetCentroCustoDropDownRequest): Promise<GetCentroCustoDropDownResponse> {
    let url = '/commons/centro-custo/dropdown';
    if (request.IdContrato !== null && request.IdContrato !== undefined) {
      url = `${url}/${request.IdContrato}`;
    }

    try {
      const result = await axiosInstance({}).get(url);
      const response = handleAxiosResponse<CentroCustoDropDownDao[]>(result);
      return { itens: response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getCentroCustoEmpreendimentoDropDown(idEmpreendimento?: number | null): Promise<GetCentroCustoDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(`/commons/centro-custo/dropdown/empreendimento`, {
        params: idEmpreendimento ? { idEmpreendimento } : undefined,
      });
      const response = handleAxiosResponse<CentroCustoDropDownDao[]>(result);
      return { itens: response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getIndicadoresDropDown(): Promise<GetIndicadoresDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(`/commons/indicadores/dropdown`);
      const response = handleAxiosResponse<IndicadoresDropDownDao[]>(result);
      return { itens: response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getClienteDropDown(request: GetClienteDropDownListRequest): Promise<GetClienteDropDownListResponse> {
    try {
      const url = request.idCentroCusto != null
        ? `/commons/clientes/dropdown/${request.idCentroCusto}`
        : `/commons/clientes/dropdown`;

      const result = await axiosInstance({}).get(url);
      const response = handleAxiosResponse<GetClienteDropDownDao[]>(result);
      return { items: response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getProdutoServicoDropDown(tipo: string): Promise<GetDropDownProdutoServicoResponse[]> {
    try {
      const result = await axiosInstance({}).get(`/commons/produtoservico/dropdown/${tipo}`);
      const response = handleAxiosResponse<GetDropDownProdutoServicoResponse[]>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getColetaPrecoDropDown(request: GetColetaPrecoDropDownRequest): Promise<GetColetaPrecoDropDownResponse> {
    try {
      const result = await axiosInstance({}).post(`/commons/coleta-precos/dropdown`, request);
      const response = handleAxiosResponse<GetColetaPrecoDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getChecklistEntregaObraDropDown(): Promise<GetDropDownResponse[]> {
    try {
      const result = await axiosInstance({}).get(`/commons/checklist-entrega-obra/dropdown`);
      const response = handleAxiosResponse<GetDropDownResponse[]>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getEmpreendimentoDropDown(idObra?: number | null): Promise<GetDropDownResponse[]> {
    try {
      const result = await axiosInstance({}).get(`/commons/empreendimento/dropdown`, {
        params: idObra ? { idObra } : undefined,
      });
      const response = handleAxiosResponse<GetDropDownResponse[]>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getTermosDropDown(): Promise<GetDropDownResponse[]> {
    try {
      const result = await axiosInstance({}).get(`/commons/termos/dropdown`);
      const response = handleAxiosResponse<GetDropDownResponse[]>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getClienteCentroCustoDropDown(request: GetClienteCentroCustoDropDownRequest): Promise<GetClienteCentroCustoDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(`/commons/clientes-centro-custo/dropdown`, request);
      const response = handleAxiosResponse<GetClienteCentroCustoDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getProjetosDropDown(request: GetProjetosDropDownRequest): Promise<GetProjetosDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(`/commons/projetos/dropdown/${request.idCentroCusto}`);
      const response = handleAxiosResponse<GetProjetosDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }


  async getMedicaoTerceirizacaoDropDown(): Promise<GetDropDownResponse[]> {
    try {
      const result = await axiosInstance({}).get(`/commons/medicaoterceirizacao/dropdown`);
      const response = handleAxiosResponse<GetDropDownResponse[]>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getCargosDropDown(): Promise<GetCargosDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(`/commons/cargos/dropdown`);
      const response = handleAxiosResponse<GetCargosDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getOrdemComprasDropDown(request: GetOrdemCompraDropDownRequest): Promise<GetOrdemCompraDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(`/commons/ordemcompras/dropdown`);
      const response = handleAxiosResponse<GetOrdemCompraDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getSubcontasDropDown(): Promise<GetSubcontaDropDownResponse> {
    try {

      const result = await axiosInstance({}).get(`/commons/subcontas/dropdown`);
      const response = handleAxiosResponse<SubContaDropDownDao[]>(result);
      return { items: [...response] };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getBancosPagamentoDropDown(): Promise<GetBancoDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(`/commons/bancospagamento/dropdown`);
      const response = handleAxiosResponse<BancoDropDownDao[]>(result);
      return { items: [...response] };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getFuncionariosDropDown(request: GetFuncionariosDropDownRequest): Promise<GetFuncionariosDropDownResponse> {
    try {
      const result = await axiosInstance({}).post(`/commons/funcionarios/dropdown`, request);
      const response = handleAxiosResponse<GetFuncionariosDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getUsuarioDropDown(): Promise<GetUsuarioDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(`/commons/usuarios/dropdown`);
      const response = handleAxiosResponse<UsuarioDropDownDao[]>(result);
      return { itens: response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getPageSize(request: GetPageSizeRequest): Promise<GetPageSizeResponse> {
    try {
      const result = await axiosInstance({}).get(`/commons/page-size/${request.idPage}`);
      const response = handleAxiosResponse<GetPageSizeResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllLogAlteracao(request: GetAllLogAlteracaoRequest): Promise<GetAllLogAlteracaoResponse> {
    try {
      const result = await axiosInstance({}).post(`/log/alteracoes`, request);
      const response = handleAxiosResponse<GetAllLogAlteracaoByParentResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllLogAlteracaoByParent(request: GetAllLogAlteracaoByParentRequest): Promise<GetAllLogAlteracaoByParentResponse> {
    try {
      const result = await axiosInstance({}).post(`/log/alteracoes/parent`, request);
      const response = handleAxiosResponse<GetAllLogAlteracaoByParentResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getFuncionariosByIdCentroCustoDropDown({ idCentroCusto, ...request }: GetFuncionariosByIdCentroCustoDropDownRequest): Promise<GetFuncionariosByIdCentroCustoDropDownResponse> {
    try {
      const result = await axiosInstance({}).post(`/commons/funcionarios/dropdown/${idCentroCusto}`, request);
      const response = handleAxiosResponse<GetFuncionariosByIdCentroCustoDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getFornecedorDropDown(request: GetFornecedorDropDownRequest): Promise<GetFornecedorDropDownResponse> {
    try {
      const result = await axiosInstance({}).post(`/commons/fornecedores/dropdown`, request);
      const response = handleAxiosResponse<GetFornecedorDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getNomeAuditorDropDown(request: GetAllAuditorAuditoresRequest): Promise<GetNomeAuditorDropDownResponse> {
    try {
      const result = await axiosInstance({}).post(`/commons/nomeauditor/dropdown`, request);
      const response = handleAxiosResponse<GetNomeAuditorDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getDataAuditoriaDropDown(request: GetDataAuditoriaDropDownRequest): Promise<GetDataAuditoriaDropDownResponse> {
    try {
      const result = await axiosInstance({}).post(`/commons/dataauditoria/dropdown`, request);
      const response = handleAxiosResponse<GetDataAuditoriaDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getDataCronogramaSGQDropDown(request: GetDataCronogramaSGQDropDownRequest): Promise<GetDataCronogramaSGQDropDownResponse> {
    try {
      const result = await axiosInstance({}).post(`/commons/dataCronogramaSGQ/dropdown`, request);
      const response = handleAxiosResponse<GetDataCronogramaSGQDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getDataProvisaoRecursoDropDown(request: GetDataProvisaoRecursoDropDownRequest): Promise<GetDataProvisaoRecursoDropDownResponse> {
    try {
      const result = await axiosInstance({}).post(`/commons/dataProvisaoRecurso/dropdown`, request);
      const response = handleAxiosResponse<GetDataProvisaoRecursoDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }


  async getUnidadesDropDown(request: GetUnidadeDropDownRequest): Promise<GetUnidadeDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(`/commons/unidade/dropdown`);
      const response = handleAxiosResponse<GetUnidadeDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getContratosFinanceiroDropDown(request: GetContratoFinanceiroRequest): Promise<GetContratoFinanceiroResponse> {
    try {
      const result = await axiosInstance({}).get(`/commons/contrato-financeiro/dropdown/${request.idIndiceReajuste}`);
      const response = handleAxiosResponse<GetContratoFinanceiroResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }



  async getAllGedDocumento(request: GetAllGedDocumentoRequest): Promise<GetAllGedDocumentoResponse> {
    try {
      const result = await axiosInstance({}).post(`/commons/ged/documento`, request);
      const response = handleAxiosResponse<GetAllGedDocumentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createGedDocumento(request: CreateGedDocumentoRequest): Promise<CreateGedDocumentoResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { 'Content-Type': 'multipart/form-data' } };
      const result = await axiosInstance({}).post(`/commons/ged/documento/create`, formData, options);
      const response = handleAxiosResponse<CreateGedDocumentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateGedDocumento(request: UpdateGedDocumentoRequest): Promise<UpdateGedDocumentoResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { 'Content-Type': 'multipart/form-data' } };
      const result = await axiosInstance({}).post(`/commons/ged/documento/update`, formData, options);
      const response = handleAxiosResponse<UpdateGedDocumentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteGedDocumento(request: DeleteGedDocumentoRequest): Promise<DeleteGedDocumentoResponse> {
    try {
      const result = await axiosInstance({}).post(`/commons/ged/documento/delete`, request);
      const response = handleAxiosResponse<DeleteGedDocumentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async copyGedDocumento(request: CopyGedDocumentoRequest): Promise<CopyGedDocumentoResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { 'Content-Type': 'multipart/form-data' } };
      const result = await axiosInstance({}).post(`/commons/ged/documento/copy`, formData, options);
      const response = handleAxiosResponse<CopyGedDocumentoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }


  async createClienteSimplificado(form: CreateClienteSimplificadoRequest): Promise<CreateClienteSimplificadoResponse> {
    try {
      const result = await axiosInstance({}).post(`/commons/clientes/createsimple`, form);
      const response = handleAxiosResponse<CreateClienteSimplificadoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createSubcontaSimplificado(form: CreateSubcontaSimplificadoRequest): Promise<CreateSubcontaSimplificadoResponse> {
    try {
      const result = await axiosInstance({}).post(`/commons/subcontas/createsimple`, form);
      const response = handleAxiosResponse<CreateSubcontaSimplificadoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getFuncionarioByIdUsuario(request: GetFuncionarioByIdUsuarioRequest): Promise<GetFuncionarioByIdUsuarioResponse> {
    try {
      const result = await axiosInstance({}).post(`/commons/funcionario-by-id-usuario`, request);
      const response = handleAxiosResponse<GetFuncionarioByIdUsuarioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getFornecedorDadosByCnpj(request: GetFornecedorDadosByCnpjRequest): Promise<GetFornecedorDadosByCnpjResponse> {
    try {
      const result = await axiosInstance({}).post(`/commons/fornecedor-dados-by-cnpj`, request.cnpj);
      const response = handleAxiosResponse<GetFornecedorDadosByCnpjResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getFuncionariosTercDropDown(request: GetFuncionariosTercDropDownRequest): Promise<GetFuncionariosTercDropDownResponse> {
    try {
      const result = await axiosInstance({}).post(`/commons/funcionarios-terc/dropdown`, request);
      const response = handleAxiosResponse<GetFuncionariosTercDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getEquipamentosDropDown(): Promise<GetEquipamentosDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(`/commons/equipamentos/dropdown`);
      const response = handleAxiosResponse<EquipamentosDropDownDao[]>(result);
      return { itens: response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getProdutosServicosDropDown(request: GetProdutosServicosDropDownRequest): Promise<GetProdutosServicosDropDownResponse> {
    try {
      const result = await axiosInstance({}).post(`/commons/produtos-servicos/dropdown`, request);
      const response = handleAxiosResponse<GetProdutosServicosDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getContratoDropDown(): Promise<GetContratoDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(`/commons/contrato/dropdown`);
      const response = handleAxiosResponse<GetContratoDropDownDao[]>(result);
      return { itens: response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getProdutoServicoContratoDropDown(idContrato: number): Promise<GetDropDownResponse[]> {
    try {
      const result = await axiosInstance({}).get(`/commons/produtoservicocontrato/dropdown/${idContrato}`);
      const response = handleAxiosResponse<GetDropDownResponse[]>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }


  async getRequisicaoCompraDropDown(request: GetRequisicaoCompraDropDownRequest): Promise<GetRequisicaoCompraDropDownResponse> {
    try {
      const result = await axiosInstance({}).post(`/commons/requisicoes-compras/dropdown`, request);
      const response = handleAxiosResponse<GetRequisicaoCompraDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }


  async getReportDropDownEntregaObraCliente(idEntregaObra: number): Promise<GetDropDownResponse[]> {
    try {
      const result = await axiosInstance({}).get(`/commons/entrega-obra-cliente/report/dropdown-cliente/${idEntregaObra}`);
      const response = handleAxiosResponse<GetDropDownResponse[]>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportDropDownEntregaObraUnidade(idEntregaObra: number): Promise<GetDropDownResponse[]> {
    try {
      const result = await axiosInstance({}).get(`/commons/entrega-obra-cliente/report/dropdown-unidade/${idEntregaObra}`);
      const response = handleAxiosResponse<GetDropDownResponse[]>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportDropDownEntregaObraChecklist(idEntregaObra: number): Promise<GetDropDownResponse[]> {
    try {
      const result = await axiosInstance({}).get(`/commons/entrega-obra-cliente/report/dropdown-checklist/${idEntregaObra}`);
      const response = handleAxiosResponse<GetDropDownResponse[]>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getReportDropDownEntregaObraLocal(idEntregaObra: number): Promise<GetDropDownResponse[]> {
    try {
      const result = await axiosInstance({}).get(`/commons/entrega-obra-cliente/report/dropdown-local/${idEntregaObra}`);
      const response = handleAxiosResponse<GetDropDownResponse[]>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAtributosCompra(request: GetAtributosCompraRequest): Promise<GetAtributosCompraResponse> {
    try {
      const result = await axiosInstance({}).post(`/commons/atributos-compras`, request);
      const response = handleAxiosResponse<GetAtributosCompraResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }


  async getGruposAcessoDropDown(): Promise<GetGrupoAcessoDropDownResponse> {
    try {
      const result = await axiosInstance({}).get(`/commons/grupos-acesso/dropdown`);
      const response = handleAxiosResponse<GetGrupoAcessoDropDownResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async gedTornarObsoletos(request: GEDTornarObsoletosRequest): Promise<GEDTornarObsoletosResponse> {
    try {
      const result = await axiosInstance({}).post(`/commons/ged/tornar-obsoleto`, request);
      const response = handleAxiosResponse<GEDTornarObsoletosResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getGedArquivoData({ idArquivoModulo }: GetGedArquivoDataRequest): Promise<Blob> {
    try {
      const result = await axiosInstance({ responseType: 'blob' }).get(`/commons/ged/${idArquivoModulo}/arquivo`);
      const response = handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getGedArquivoPdfData({ idArquivoModulo }: GetGedArquivoPdfDataRequest): Promise<Blob> {
    try {
      const result = await axiosInstance({ responseType: 'blob' }).get(`/commons/ged/${idArquivoModulo}/arquivo/pdf`);
      const response = handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getProdutoServicoEsDropDown(IdControleEstoque: number): Promise<GetDropDownResponse[]> {
    try {
      const result = await axiosInstance({}).get(`/commons/produtoservicoEstoque/dropdown/${IdControleEstoque}`);
      const response = handleAxiosResponse<GetDropDownResponse[]>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#region Principal
  async getAllListagemDoc(request: GetPrincipalDocRequest): Promise<GetPrincipalDocResponse> {
    try {
      const result = await axiosInstance({}).post(`commons/principal/listDocumentos`, request);
      const response = handleAxiosResponse<GetPrincipalDocResponse>(result);

      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion

  async saveUsuarioTableScheme(request: SaveUsuarioTableSchemeRequest): Promise<SaveUsuarioTableSchemeResponse> {
    try {
      const result = await axiosInstance({}).post(`commons/save-table-scheme`, request);
      const response = handleAxiosResponse<SaveUsuarioTableSchemeResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
}
